var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63761 9.47488L0.425105 5.27488C0.375105 5.22488 0.339605 5.17071 0.318605 5.11238C0.297605 5.05404 0.287272 4.99154 0.287605 4.92488C0.287605 4.85821 0.297939 4.79571 0.318605 4.73738C0.339272 4.67904 0.374772 4.62488 0.425105 4.57488L4.63761 0.362378C4.75427 0.245711 4.9001 0.187378 5.07511 0.187378C5.25011 0.187378 5.4001 0.249878 5.5251 0.374878C5.6501 0.499878 5.7126 0.645711 5.7126 0.812378C5.7126 0.979045 5.6501 1.12488 5.5251 1.24988L1.85011 4.92488L5.5251 8.59988C5.64177 8.71655 5.70011 8.86038 5.70011 9.03138C5.70011 9.20238 5.63761 9.35021 5.51261 9.47488C5.38761 9.59988 5.24177 9.66238 5.07511 9.66238C4.90844 9.66238 4.76261 9.59988 4.63761 9.47488Z",
    fill: "#ABB3BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0488253e76e2f7ef52b6d80d9ddb926f.svg";
export { ForwardRef as ReactComponent };